import React from "react";

interface IconProps {
	className?: string;
	size?: number;
}

// From docs/design/fi_4945336.svg (winners podium).
const PodiumIcon: React.FC<IconProps> = ({ className = "", size = 20 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g clipPath="url(#clip_podium)">
				<path d="M7.61188 4.56601L7.3822 5.90195C7.35145 6.08151 7.37155 6.2661 7.44021 6.43484C7.50888 6.60358 7.62338 6.74975 7.77077 6.85683C7.91816 6.96391 8.09256 7.02762 8.27426 7.04077C8.45596 7.05392 8.63772 7.01598 8.79899 6.93125L9.99938 6.30078L11.199 6.93125C11.3603 7.0162 11.5421 7.05431 11.724 7.04127C11.9058 7.02822 12.0804 6.96454 12.2279 6.85743C12.3754 6.75032 12.49 6.60406 12.5587 6.4352C12.6274 6.26634 12.6474 6.08162 12.6166 5.90195L12.3877 4.56601L13.3588 3.62031C13.4897 3.49306 13.5824 3.33165 13.6262 3.15439C13.67 2.97714 13.6633 2.79115 13.6068 2.61753C13.5502 2.44391 13.4461 2.28962 13.3063 2.17218C13.1665 2.05474 12.9966 1.97885 12.8158 1.95312L11.4748 1.75781L10.8752 0.544526C10.7945 0.38109 10.6698 0.243476 10.515 0.147252C10.3602 0.0510269 10.1816 3.05176e-05 9.99938 3.05176e-05C9.81714 3.05176e-05 9.63853 0.0510269 9.48376 0.147252C9.32899 0.243476 9.20423 0.38109 9.1236 0.544526L8.52399 1.75976L7.18259 1.95507C7.00225 1.98114 6.8328 2.05713 6.69339 2.17447C6.55399 2.29181 6.4502 2.44581 6.39375 2.61906C6.3373 2.79231 6.33045 2.97789 6.37397 3.15483C6.41748 3.33177 6.50964 3.49301 6.64001 3.62031L7.61188 4.56601Z" fill="currentColor" />
				<path d="M11.5625 8.28125H8.4375C8.0749 8.28125 7.72715 8.42529 7.47075 8.68169C7.21436 8.93809 7.07031 9.28584 7.07031 9.64844V16.4844H12.9297V9.64844C12.9297 9.28584 12.7856 8.93809 12.5292 8.68169C12.2729 8.42529 11.9251 8.28125 11.5625 8.28125Z" fill="currentColor" />
				<path d="M0 17.6562V19.0234C0 19.2824 0.102888 19.5308 0.286029 19.714C0.46917 19.8971 0.717562 20 0.976562 20H19.0234C19.2824 20 19.5308 19.8971 19.714 19.714C19.8971 19.5308 20 19.2824 20 19.0234V17.6562H0Z" fill="currentColor" />
				<path d="M17.6172 12.3828C17.6172 12.0202 17.4731 11.6725 17.2167 11.4161C16.9604 11.1597 16.6126 11.0156 16.25 11.0156H14.1016V16.4844H17.6172V12.3828Z" fill="currentColor" />
				<path d="M5.89844 12.9688H3.75C3.3874 12.9688 3.03965 13.1128 2.78325 13.3692C2.52685 13.6256 2.38281 13.9733 2.38281 14.3359V16.4844H5.89844V12.9688Z" fill="currentColor" />
			</g>
			<defs>
				<clipPath id="clip_podium">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default PodiumIcon;
